import React, { useEffect, useState } from 'react';
import { LinearProgress, Typography, Cindy } from '@ace-clublabs/shared-component-library';
import checked_icon from '../assets/checked.svg';
import unchecked_icon from '../assets/unchecked.svg';
import Header from './Header';
import { useGlobalState } from '../shared/state';

export interface ProcessingProps {
  text?: string;
  renderCindy?: boolean;
  displayCheckmark?: boolean;
  onFinished?: any;
}
const Processing: React.FC<ProcessingProps> = (props) => {
  const [isScheduled] = useGlobalState('isScheduled');
  const [manifest] = useGlobalState('manifest');
  const [isChecked, setIsChecked] = useState(false);
  const { text, renderCindy, displayCheckmark, onFinished } = props || {};
  let processingText = 'Your payment is being processed';

  if (text) processingText = text;
  else if (manifest?.appId == 'manage-saved-payments') {
    processingText = 'Saving your payment method';
  } else if (manifest?.autoPay && manifest?.amount === 0) {
    processingText = 'Your Auto Pay enrollment is being processed';
  } else if (isScheduled) {
    processingText = 'Your scheduled payment is being processed';
  }

  useEffect(() => {
    if (!displayCheckmark) {
      return;
    }
    setIsChecked(true);
    const id = window.setTimeout(() => {
      onFinished?.();
    }, 1000);
    return () => window.clearTimeout(id);
  }, [displayCheckmark, onFinished]);

  return (
    <div className="inner-container processing">
      <Header />
      <LinearProgress id="progress-bar" variant={'indeterminate'} sx={{ height: '8px', marginBottom: '24px' }} />
      <Typography variant="b1Regular" id="processing-text">
        {isChecked ? (
          <img src={checked_icon} alt="checked icon" className="checked-icon" />
        ) : (
          <img src={unchecked_icon} alt="unchecked icon" className="unchecked-icon" />
        )}
        {processingText}
      </Typography>
      {renderCindy && (
        <Cindy id="cindy" sx={{ marginTop: '22px' }}>
          Please get your payment method ready.
        </Cindy>
      )}
    </div>
  );
};

export default Processing;
